import { CitySearchSuggestion } from '@city/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CityState, StateWithCity } from '../city-state';
import { getCityState } from './feature.selector';

export const getCitySearchState: MemoizedSelector<
  StateWithCity,
  StateUtils.LoaderState<CitySearchSuggestion[]>
> = createSelector(getCityState, (state: CityState) => state.citySuggestions);

export const getCitySearchValue: MemoizedSelector<StateWithCity, CitySearchSuggestion[]> = createSelector(
  getCitySearchState,
  (state: StateUtils.LoaderState<CitySearchSuggestion[]>) => StateUtils.loaderValueSelector(state),
);

export const getCitySearchLoading: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getCitySearchState,
  (state: StateUtils.LoaderState<CitySearchSuggestion[]>) => StateUtils.loaderLoadingSelector(state),
);

export const getCitySearchError: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getCitySearchState,
  (state: StateUtils.LoaderState<CitySearchSuggestion[]>) => StateUtils.loaderErrorSelector(state),
);

export const getCitySearchSuccess: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getCitySearchState,
  (state: StateUtils.LoaderState<CitySearchSuggestion[]>) => StateUtils.loaderSuccessSelector(state),
);
